import React from 'react';
import { Box } from '@mui/joy';
import { Tag } from '../Snippet';
import { useTranslation } from 'react-i18next';

const CellCarcalendar = ({ type, value, field }) => {

    const { t } = useTranslation()

    //const label = value ? typeof value === 'string' ? value : value[field] : undefined
    const label = value?.car?.plate;
    return (
        <Box className={"list-element-cell cell-generics cell-generics-" + type}>
            {label
                ? <Tag className="name" title={label}>{label}</Tag>
                : <Tag>{t('missing')}</Tag>
            }
        </Box>
    )

}

export default CellCarcalendar;